export const email = 'kumaun.retailstore@retailapp.com';
export const phone = '6397499593';
export const address = 'Shiv Colony, Haldwani, Uttarakhand, 263139';
